import { useQuery } from '@tanstack/react-query'
import cacheKeys from '../../../../services/cacheKeys'
import { notificationCount } from '../index'

const useNotificationCount = () => {
  return useQuery({
    queryKey: [cacheKeys.NOTIFICATION_COUNT],
    queryFn: notificationCount,
  })
}

export default useNotificationCount
